import script from "./DeleteVideoModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteVideoModal.vue?vue&type=script&lang=ts&setup=true"

import "./DeleteVideoModal.vue?vue&type=style&index=0&id=48f4b46e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f4b46e"]])

export default __exports__